
document.addEventListener('DOMContentLoaded', function() {
 
  var acc = document.getElementsByClassName("accordionHeader"); 
  var i; 
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
  
      /* custom fix to close opened accordions on product page*/ 
      document.querySelectorAll('.accordionHeader').forEach((details)=>{
        if(details != this)
        details.classList.remove("active");        
      });
      document.querySelectorAll('.accordionPanel').forEach((summary)=>{
        if(summary != this.nextElementSibling)
        summary.style.maxHeight = null;
      }); 
      /* fix end here */
      
  
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }



  var acc = document.getElementsByClassName("accordionHeader2");
  var i; 
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
  
      /* custom fix to close opened accordions on product page*/ 
      document.querySelectorAll('.accordionHeader2').forEach((details)=>{
        if(details != this)
        details.classList.remove("active");        
      });
      document.querySelectorAll('.accordionPanel2').forEach((summary)=>{
        if(summary != this.nextElementSibling)
        summary.style.maxHeight = null;
      }); 
      /* fix end here */
      
    
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 

      var itemthis =this;
  
      /** 🔄 Refresh parent height **/
      var parent = itemthis.closest(".accordionPanel"); // <-- parent container
      if (parent) {
        // Force reflow to allow transition
        parent.style.maxHeight = parent.scrollHeight + "px"; 
      }  

    });
  }



});



function accordionInitForComp(item){
    var elementItem = document.querySelector(item);
  
    /* custom fix to close opened accordions on product page*/ 
    document.querySelectorAll('.accordionHeader').forEach((details)=>{
      if(details != elementItem)
      details.classList.remove("active");        
    });
    document.querySelectorAll('.accordionPanel').forEach((summary)=>{
      if(summary != elementItem.nextElementSibling)
      summary.style.maxHeight = null;
    }); 
    /* fix end here */
    
 
    elementItem.classList.toggle("active");
    var panel = elementItem.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
}






var accFooter = document.getElementsByClassName("accordion-footer");
var i; 
for (i = 0; i < accFooter.length; i++) {
  accFooter[i].addEventListener("click", function() {

    if(window.innerWidth>990)return;
 
    /* custom fix to close opened accordions on product page*/ 
    document.querySelectorAll('.accordion-footer').forEach((details)=>{
      if(details != this)
      details.classList.remove("active");        
    });
    document.querySelectorAll('.accordionPanelFooter').forEach((summary)=>{
      if(summary != this.nextElementSibling)
      summary.style.maxHeight = null;
    }); 
    /* fix end here */
    
 
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


// assigning fixed heights to enable animations properly.
  document.querySelectorAll('.product__info-container .accordionHeader').forEach(header => {
    const panel = header.nextElementSibling; // .accordionPanel
    if (!panel) return;

    if (header.classList.contains('active')) {
      // set to scrollHeight for smooth animation
      panel.style.maxHeight = panel.scrollHeight + "px";
    }  
  });



/*
function filter_accordions(){
  if(!document.querySelector("#FacetFiltersFormMobile.mobile-facets--accordion"))return;

  var acc = document.getElementsByClassName("filters_accordions");
  var i; 
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
   
      document.querySelectorAll('.filters_accordions').forEach((details)=>{
        if(details != this)
        details.classList.remove("active");        
      });
      document.querySelectorAll('.filters_panel').forEach((summary)=>{
        if(summary != this.nextElementSibling)
        summary.style.maxHeight = null;
      });  
      
  
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
}
 
document.addEventListener("DOMContentLoaded", (event) => {
    filter_accordions();
});
 */

// Run once on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#FacetFiltersFormMobile.mobile-facets--accordion');
  if (!container) return;

  // Event delegation: single handler for all current/future .filters_accordions
  container.addEventListener('click', (event) => {
    const header = event.target.closest('.filters_accordions');
    if (!header || !container.contains(header)) return;

    // Close other open accordions
    container.querySelectorAll('.filters_accordions.active').forEach((el) => {
      if (el !== header) {
        el.classList.remove('active');
        const p = el.nextElementSibling;
        if (p) p.style.maxHeight = null;
      }
    });

    // Toggle clicked one
    header.classList.toggle('active');
    const panel = header.nextElementSibling;
    if (!panel) return;

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      // Use scrollHeight so it works with dynamic content
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });

  // Helper: if AJAX loads images or content that changes scrollHeight,
  // call this to recompute maxHeight for any already-open panel(s).
  const refreshOpenPanels = () => {
    container.querySelectorAll('.filters_accordions.active').forEach(h => {
      const p = h.nextElementSibling;
      if (p) {
        // Force reflow and set the new height
        p.style.maxHeight = null;
        // Give browser a tick if you like: but generally direct set is fine
        p.style.maxHeight = p.scrollHeight + 'px';
      }
    });
  };

  // Recompute on window resize (panels might wrap/change height)
  window.addEventListener('resize', refreshOpenPanels);

  // OPTIONAL: auto-refresh if AJAX replaces children of container
  // (this avoids having to call refreshOpenPanels yourself after every AJAX)
  const observer = new MutationObserver((mutations) => {
    // small debounce
    clearTimeout(observer._debounce);
    observer._debounce = setTimeout(() => {
      refreshOpenPanels();
    }, 50);
  });
  observer.observe(container, { childList: true, subtree: true });

  // If you don't want MutationObserver, call refreshOpenPanels()
  // after your AJAX finishes and inserts the new HTML.
});



const drawer = document.querySelector("cart-drawer.drawer");
if (drawer) {
  drawer.addEventListener("click", function (e) {
    const inner = document.querySelector("#CartDrawer");

    // If click happened directly on drawer (overlay area)
    if (!inner.contains(e.target)) {
      drawer.close();
    }
  });
}


(() => {
  const CM_PER_IN = 2.54;

  const isNumeric = (val) => /^-?\d+(\.\d+)?$/.test(String(val).trim());

  const formatInches = (cmString) => {
    const cm = parseFloat(cmString);
    if (Number.isNaN(cm)) return cmString;
    // 1 decimal, trim trailing .0
    const n = parseFloat((cm / CM_PER_IN).toFixed(1));
    return String(n);
  };

  const initChart = (chartEl) => {
    const table = chartEl.querySelector("table");
    if (!table) return;

    const rows = Array.from(table.querySelectorAll("tbody tr"));
    if (!rows.length) return;

    // Cache original CM values for all data cells except first column ("size")
    rows.forEach((tr, rowIndex) => {
      // Row 0 is header row in your markup (tds). Keep it as labels.
      if (rowIndex === 0) return;

      const cells = Array.from(tr.querySelectorAll("td"));
      cells.forEach((td, cellIndex) => {
        if (cellIndex === 0) return; // don't convert "size"
        const txt = td.textContent.trim();
        if (!isNumeric(txt)) return;
        td.dataset.cm = txt; // store original cm
      });
    });

    const buttons = Array.from(chartEl.querySelectorAll("[data-unit]"));
    const setUnit = (unit) => {
      // Update buttons
      buttons.forEach((btn) => {
        const isActive = btn.dataset.unit === unit;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      // Update table values
      rows.forEach((tr, rowIndex) => {
        if (rowIndex === 0) return;

        const cells = Array.from(tr.querySelectorAll("td"));
        cells.forEach((td, cellIndex) => {
          if (cellIndex === 0) return;
          const cmVal = td.dataset.cm;
          if (!cmVal) return;

          td.textContent = unit === "in" ? formatInches(cmVal) : cmVal;
        });
      });

      chartEl.dataset.unit = unit;
    };

    // Bind events
    chartEl.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-unit]");
      if (!btn) return;
      setUnit(btn.dataset.unit);
    });

    // Default
    setUnit("cm");
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-size-chart]").forEach(initChart);
  });
})();
